import type { ExplorerFinding } from '../../../../models/explorer/ExplorerFinding';
import type { FindingRule, FindingRuleContext } from '../types';
import { groupByTier } from '../../../../canvas/tierGrouping';

export const strandedDataRule: FindingRule = {
  id: 'stranded_data',
  label: 'Stranded data',
  description: 'Data stores in a VPC with no compute.',

  run(ctx: FindingRuleContext): readonly ExplorerFinding[] {
    const findings: ExplorerFinding[] = [];
    for (const b of ctx.bubbles) {
      if (b.kind !== 'vpc') continue;
      const bands = groupByTier(b.interior ?? []);
      const count = (tier: string) =>
        bands.find((band) => band.tier === tier)?.dots.length ?? 0;
      const compute = count('compute');
      const data = count('data');
      const ingress = count('ingress');

      if (data > 0 && compute === 0) {
        findings.push({
          id: `stranded_data:bubble:${b.id}`,
          ruleId: 'stranded_data',
          severity: 'warn',
          scope: 'bubble',
          subject: { kind: 'bubble', id: b.id },
          title: 'Stranded data',
          detail: `${data} data store(s) in a VPC with no compute — forgotten backend or compliance gap.`,
        });
      }

      if (ingress > 0 && compute > 0 && ingress > compute) {
        findings.push({
          id: `over_exposed:bubble:${b.id}`,
          ruleId: 'over_exposed',
          severity: 'warn',
          scope: 'bubble',
          subject: { kind: 'bubble', id: b.id },
          title: 'Over-exposed',
          detail: `${ingress} ingress points for only ${compute} compute resources — probable orphan load balancers.`,
        });
      }
    }
    return findings;
  },
};
